export default () => {
    try {
        return JSON.parse(localStorage.getItem('userSummary'))?.marketingGroups || []
    } catch (e) {
        return []
    } 
}